import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from './components/organisms/Layout'
import PrivateRoute from './utils/PrivateRoute'
import NotFound from './pages/NotFound'
import LoginPage from './pages/auth/LoginPage'
import 'yet-another-react-lightbox/styles.css'

const Homepage = lazy(() => import('./pages/Homepage'))
const AddEditPage = lazy(() => import('./pages/AddEditPage'))
const UneadReport = lazy(() => import('./pages/report/unread-report'))
const CategoryReport = lazy(() => import('./pages/report/category-report'))
const ChapterReport = lazy(() => import('./pages/report/chapter-report'))
const BaseChapterReport = lazy(() => import('./pages/report/base-chapter-report'))
const SettingCategories = lazy(() => import('./pages/settings/categories'))
const SettingDepartments = lazy(() => import('./pages/settings/departments'))
const SettingLocations = lazy(() => import('./pages/settings/locations'))
const SettingTaskNightShift = lazy(() => import('./pages/settings/tasks-night-shift'))
const SettingTaskPublicArea = lazy(() => import('./pages/settings/tasks-public-area'))
const SettingChapters = lazy(() => import('./pages/settings/chapters'))
const UserManagement = lazy(() => import('./pages/users'))
const UpdateUser = lazy(() => import('./pages/users/UpdateUser'))
const UpdatePersonalProfile = lazy(() => import('./pages/users/UpdatePersonalProfile'))
const AddChecklistTaskPage = lazy(() => import('./pages/task/checklist-task'))
const AddCustomTaskPage = lazy(() => import('./pages/task/custom-task'))
const AddPublicAreaTaskPage = lazy(() => import('./pages/task/public-area-task'))

const renderLoader = () => <p>Loading</p>

const App = () => (
  <Suspense fallback={renderLoader()}>
    <Routes>
      <Route path="/" element={<PrivateRoute component={Layout} />}>
        <Route index element={<Homepage />} />
        <Route path="addnew" element={<AddEditPage />} />
        <Route path="edit/:code" element={<AddEditPage isEdit />} />
        <Route path="update-profile" element={<UpdatePersonalProfile />} />
      </Route>
      <Route path="/report" element={<PrivateRoute component={Layout} />}>
        <Route path="unread-report" element={<UneadReport />} />
        <Route path="category-report" element={<CategoryReport />} />
        <Route path="base-chapter-report" element={<BaseChapterReport />} />
        <Route path="chapter-report" element={<ChapterReport />} />
      </Route>
      <Route path="/tasks-list" element={<PrivateRoute component={Layout} />}>
        <Route path="middle" element={<AddCustomTaskPage />} />
        <Route path="night" element={<AddChecklistTaskPage />} />
        <Route path="public-area" element={<AddPublicAreaTaskPage />} />
      </Route>
      <Route path="/user-management" element={<PrivateRoute component={Layout} />}>
        <Route index element={<UserManagement />} />
      </Route>
      <Route path="/setting" element={<PrivateRoute component={Layout} />}>
        <Route path="categories" element={<SettingCategories />} />
        <Route path="tasks-night-shift" element={<SettingTaskNightShift />} />
        <Route path="tasks-public-area" element={<SettingTaskPublicArea />} />
        <Route path="chapters" element={<SettingChapters />} />
        <Route path="departments" element={<SettingDepartments />} />
        <Route path="locations" element={<SettingLocations />} />
      </Route>
      <Route path="login" element={<LoginPage />} />
      <Route path="update-user" element={<UpdateUser />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
)

export default App
